import Vue from 'vue';
import { apiPath } from '../constants';

const keywordPlannerResource = Vue.resource(
  `${apiPath}/adbazaar/insights/keyword-planner`,
  {},
  {
    getKeywordPlannerInsight: {
      method: 'POST',
    },
  },
);

export default keywordPlannerResource;
